import {
  FilterRequest,
  ContactStatusDoc,
  ContactStatusResponse,
  ContactStatusesResponse,
  ContactStatusLightResponse,
} from '@/types/entities';
import { ApiService } from './api.service';
import { endpoints } from './endpoints';

/**
 * Service for handling contact status-related API calls
 */
export class ContactStatusesApiService extends ApiService {
  getAll = async (): Promise<ContactStatusLightResponse> =>
    this.get(endpoints.contactStatuses.all);

  getFilteredContactStatuses = async (filters: FilterRequest): Promise<ContactStatusesResponse> =>
    this.post(endpoints.contactStatuses.filtered, filters);

  deleteContactStatus = async (id: string): Promise<void> =>
    this.delete(endpoints.contactStatuses.delete(id));

  getContactStatusById = async (id: string): Promise<ContactStatusResponse> =>
    this.get(endpoints.contactStatuses.byId(id));

  createContactStatus = async (data: Partial<ContactStatusDoc>): Promise<ContactStatusDoc> =>
    this.post(endpoints.contactStatuses.create, data);

  updateContactStatus = async (
    id: string,
    data: Partial<ContactStatusDoc>,
  ): Promise<ContactStatusDoc> => this.patch(endpoints.contactStatuses.update(id), data);

  reorderContactStatuses = async (
    items: Array<{ id: string; order: number }>,
  ): Promise<void> => this.post(endpoints.contactStatuses.reorder, { items });
}

export const contactStatusesApiService = new ContactStatusesApiService();

export const {
  getAll: getContactStatuses,
  getFilteredContactStatuses,
  deleteContactStatus,
  getContactStatusById,
  createContactStatus,
  updateContactStatus,
  reorderContactStatuses,
} = contactStatusesApiService;
